export const redirectTo = (url) => {
  if (typeof window !== `undefined` && url) {
    window.location.replace(url);
  }
};

export default redirectTo;
